import { Pipe, PipeTransform } from '@angular/core';
import { HelperService } from './helper.service';

@Pipe({ name: 'richText' })
export class RichTextPipe implements PipeTransform {
  constructor(private helper: HelperService) {}

  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }
    return this.helper.formatText(value.replace(/(\r\n|\n|\r)/gm, '<br>'));
  }
}
